import React from 'react';
import Group from '@lightspeed/cirrus-group';
import { Logo } from '@lightspeed/cirrus-ls-logo';
import Text from '@lightspeed/cirrus-text';

const Header = () => (
  <Group className="cr-justify-center cr-m-4">
    <Logo type="flame" width="24px" />
    <Text bodyXLarge className="cr-text-xxl cr-night">
      <span>Welcome to Lightspeed Retail</span>
    </Text>
  </Group>
);

export default Header;
